import { createSlice } from "@reduxjs/toolkit";
const { REACT_APP_API_URL, REACT_APP_GOOGLE_API_KEY } = process.env;

export const mapSlice = createSlice({
  name: "map",
  initialState: {
    initCoords: {},
    browserCoords: {},
    country: {},
    phone: "",
  },
  reducers: {
    setBrowserCoords: (state, action) => {
      state.browserCoords = action.payload;
    },
    setPhone: (state, action) => {
      state.phone = action.payload;
    },
    setInitCoords: (state, action) => {
      state.initCoords = action.payload;
    },
    setCountryData: (state, action) => {
      state.country = action.payload;
    },
  },
});

export const getGeoCode = async (country, city, postalCode = '') => {
  let address = `${city}, ${country}`;
  
  if (postalCode) {
    address = `${postalCode}, ${address}`;
  }
  const apiUrl = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(address)}&key=${REACT_APP_GOOGLE_API_KEY}`;
  
  return new Promise((resolve, reject) => {
    fetch(apiUrl)
      .then(response => response.json())
      .then(data => {
        if (data.status === 'OK' && data.results.length > 0) {
          const location = data.results[0].geometry.location;
          const latitude = location.lat;
          const longitude = location.lng;
          resolve({ lat: latitude, lon: longitude });
        } else {
          reject(new Error('Geocoding request failed'));
        }
      })
      .catch(error => {
        reject(error);
      });
  });
};

export const getLocationByIP = async () => {
  const url = REACT_APP_API_URL + "/cf-country";
  
  try {
    const response = await fetch(url);
    const data = await response.json();

    return data;
  } catch (error) {
    console.error("Error fetching location by IP:", error);
  }
}; 

export const getCurrentPosition = (dispatch, action) =>
  navigator.geolocation.getCurrentPosition((position) => {
    dispatch(
      action({
        browserLat: position.coords.latitude,
        browserLng: position.coords.longitude,
      })
    );
  });

export const calculateOffset = (lat, lng) => {
  const r_earth = 6371000.0;
  const dy = 3000;
  const dx = 3000;

  const newLat = lat + (dy / r_earth) * (180 / Math.PI);
  const newLng = lng + (dx / r_earth) * (180 / Math.PI);

  return {
    newLat,
    newLng,
  };
};

export const {
  setBrowserCoords,
  setPhone,
  setInitCoords,
  setCountryData,
} = mapSlice.actions;

export const selectBrowserCoords = (state) => state.map.browserCoords;
export const selectPhone = (state) => state.map.phone;
export const selectInitCoords = (state) => state.map.initCoords;
export const selectCountryData = (state) => state.map.country;

export default mapSlice.reducer;
